import { AnalyticsLibraryService } from './../../analytics-library.service';
import { CommonService } from './../../page/common.service';
import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: '[app-info-button]',
  templateUrl: './info-button.component.html',
  styleUrls: ['./info-button.component.scss']
})
export class InfoButtonComponent implements OnInit, OnChanges {
  @Input() onAction: string = null;
  @Input() isBig: boolean;
  @Input() lateralPanelId: string;

  @Output() onInfo: EventEmitter<any> = new EventEmitter();

  svgTextCords: number[] = [95, 150];
  svgRectCords: number[] = [65, 135];
  openLateralPanel: boolean = false;

  constructor(
    private cs: CommonService,
    public ap: AnalyticsLibraryService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lateralPanelId && changes.lateralPanelId.currentValue) {
      this.openLateralPanel = true;
    }
  }

  ngOnInit() {
    if (this.isBig) {
      this.svgTextCords = [165, 287];
      this.svgRectCords = [135, 270];
    }
  }

  onClickInfo() {
    this.onInfo.emit(null);
  }

  analyticsCall() {
    /* Managed with directive */
      return this.ap.getEventTrackerObj("IDS_GTAG_CATEGORY_INFO", this.lateralPanelId, "click",null,false);
  }

}
